// Same keys and prefix as the portal (src/app/utils/storage.ts), so the two never clash in a shared browser.
export const STORAGE_PREFIX = "classtutor-";

export const STORAGE_KEYS = {
  TOKEN: `${STORAGE_PREFIX}token`,
  REFRESH_TOKEN: `${STORAGE_PREFIX}refreshToken`,
  PROFILE: `${STORAGE_PREFIX}app-profile`,
  REMINDERS: `${STORAGE_PREFIX}app-reminders`,
  CONSENT: `${STORAGE_PREFIX}app-consent`,
  PUSH_KEY: `${STORAGE_PREFIX}app-pushKey`,
  PHONE_ASKED: `${STORAGE_PREFIX}app-phoneAsked`,
  CHAT_READ: `${STORAGE_PREFIX}app-chatRead`,
};

const safe = <T>(fn: () => T, fallback: T): T => { try { return fn(); } catch { return fallback; } };

const storage = {
  getItem: (key: string): string | null => safe(() => localStorage.getItem(key), null),
  setItem: (key: string, value: string) => safe(() => localStorage.setItem(key, value), undefined),
  removeItem: (key: string) => safe(() => localStorage.removeItem(key), undefined),
  getJson: <T>(key: string, fallback: T): T => safe(() => { const raw = localStorage.getItem(key); return raw ? (JSON.parse(raw) as T) : fallback; }, fallback),
  setJson: (key: string, value: unknown) => safe(() => localStorage.setItem(key, JSON.stringify(value)), undefined),
};

export default storage;
